import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';
import { BannerMessage } from '../../common/services/banner/banner-message';
import { BannerService } from '../../common/services/banner/banner.service';
import { AndroidMessageComponent } from '../component/android-message.component';
import { IosMessageComponent } from '../component/ios-message.component';

@Injectable({
    providedIn: 'root'
})
export class PwaService {

    constructor(
        private platform: Platform,
        private bannerService: BannerService
    ) {
    }

    public initPwaBanner() {
        if (this.platform.ANDROID) {
            window.addEventListener('beforeinstallprompt', (bannerEvent: any) => {
                this.bannerService.openBanner(new BannerMessage(
                    AndroidMessageComponent,
                    'DISMISS',
                    'INSTALL APP',
                    () => {
                        bannerEvent.prompt();
                    },
                    'get_app'),
                    3000
                );
            });
        }
        if (this.platform.IOS) {
            // tslint:disable-next-line:no-string-literal
            const isInStandaloneMode = ('standalone' in window.navigator) && (window.navigator['standalone']);
            if (!isInStandaloneMode) {
                this.bannerService.openBanner(new BannerMessage(
                    IosMessageComponent,
                    'DISMISS',
                    null,
                    null,
                    'get_app'), 3000);
            }
        }
    }
}
